<template>
  <div class="content article">
    <div class="article-body">
      <h1 class="article-title">The Technology</h1>
      <div class="card">
        <div class="card-content">
          <h2>Contents</h2>
          <ol>
            <li><a href="#front">Front end</a></li>
            <li><a href="#back">Back end</a></li>
            <li><a href="#vendors">Vendors</a></li>
          </ol>
          
          <h2><a id="front"></a>Front end</h2>

          <p>
            The front end is built with <a href="//vuejs.org">VueJs</a>. If you are new to VueJS, there is <a href="//vuecasts.com">video tutorial series
            for FREE DOLLARS!</a> Put together by <a href="//twitter.com/jeffrey_way">Jeffery Way</a> at <a href="//laracasts.com">Laracasts</a>. 
          </p>

          <ul>
            <li><a href="//github.com/vuejs/vue-cli">Vue-CLI</a> to scaffold out WebPack 2 and my directory structure</li>
            <li><a href="//webpack.js.org">WebPack 2</a> for module bundling &amp; build process</li>
            <li><a href="//router.vuejs.org/en">Vue-Router</a> for URL routing</li>
            <li><a href="//vuex.vuejs.org/en/intro.html">Vuex</a> for state management</li>
            <li><a href="//github.com/vuejs/vuex-router-sync">Vuex router sync</a> for keeping router in sync with storage.</li>
            <li><a href="//www.chartjs.org">ChartJS</a> for pie, bar, &amp; line charts</li>
            <li><a href="//leafletjs.com">Leaflet</a> for maps</li>
            <li><a href="//github.com/Leaflet/Leaflet.markercluster">Leaflet.markercluster</a> for clustering points on a map</li>
            <li><a href="//github.com/Leaflet/Leaflet.heat">Leaflet.heat</a> for heatmap effect on maps</li>
            <li><a href="//momentjs.com">MomentJS</a> for date formatting and manipulation</li>
            <li><a href="//github.com/dbushell/Pikaday">Pikaday</a> for date pickers</li>
            <li><a href="//meyerweb.com/eric/tools/css/reset/">Eric Meyer's CSS Reset</a> for css reset</li>
            <li><a href="//lodash.com">Lodash</a> for utility</li>
            <li><a href="//github.com/mzabriskie/axios">Axios</a> for async promise based API calls</li>
          </ul>

          <h2><a id="back"></a>Back end</h2>

          <p>
            I'm a PHP developer so I built the backend in <a href="//www.php.net">PHP</a>. I like the <a href="//laravel.com">Laravel PHP framework</a>, so I used that.
            If you're new to Laravel, guess what? There is ANOTHER <a href="//laravelfromscratch.com">video tutorial series to help you get started with Laravel</a>. Also
            for FREE DOLLARS by <a href="//twitter.com/jeffery_way">Jeffery Way</a>. Whatta guy! If you're looking for a book on Laravel, well lucky you.
            <a href="//mattstauffer.co">Matt Stauffer</a> recently published his book <a href="//laravelupandrunning.com">Laravel Up &amp; Running</a>. I bought it. It's good.
            I'm using <a href="//www.mysql.com">MySQL</a> for my database.
          </p>

          <p>
            As mentioned in <a href="/about/story#p2">the story</a>, the data is being downloaded from a 
            <a href="//data.seattle.gov/resource/v7k9-7dn4.json">json feed provided by data.seattle.gov</a>. There is a job scheduled that will download collisions 
            from the past 150 days, check for changes, then update existing collisions and create new ones. I'd like to write a blog post sometime that talks more 
            about the import process, how I transformed the data, and challenges I ran into. This is on my <router-link :to="{name: 'toDo'}">to do list</router-link>.
          </p>
          
          <h2><a id="back"></a>Vendors</h2>
          
          <ul>
            <li><a href="//www.webfaction.com/?aid=45281">WebFaction</a> for hosting the front end VueJS app</li>
            <li><a href="//www.digitalocean.com">Digital Ocean</a> for hosting the back end Laravel app serving up the API.</li>
            <li><a href="//forge.laravel.com">Laravel Forge</a> for server provisioning</li>
            <li><a href="//envoyer.io">Envoyer.io</a> for deployment</li>
            <li><a href="//www.cloudflare.com">CloudFlare</a> for DNS</li>
            <li><a href="//www.bitbucket.org">BitBucket</a> for Git repository</li>
            <li><a href="//gandi.net">Gandi</a> for domain registration</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'technology'
}
</script>

<style lang="scss">
@import "./src/sass/views/article";
@import "./src/sass/card.scss";
</style>



// WEBPACK FOOTER //
// Technology.vue?6661acde